import { get, put } from './api'

const getProfile = (userToken) => get(`users/profile?userToken=${encodeURIComponent(userToken)}`)
const updateProfile = (userToken, nickname) => put('users/profile', { userToken, nickname })

export default { getProfile, updateProfile }
